import { useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { messagesApi } from '../api/messagesApi';

export function useSmsThread(
  conversationId: string | null | undefined,
  topic?: string,
) {
  return useQuery({
    queryKey: keys.sms.thread(conversationId ?? '', topic),
    queryFn: ({ signal }) => messagesApi.getThread(conversationId!, topic, { signal }),
    enabled: conversationId != null,
    staleTime: 30_000,
  });
}

export { useEscalate, useGenerateSummary, useSmsComposeSend, useSmsReply } from './useSmsMutations';
